import Vue from 'vue'
import VueI18n from 'vue-i18n'

import ZH_TW from '../locales/zh_tw'
import EN from '../locales/en'

Vue.use(VueI18n)

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'tw',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: {
    tw: ZH_TW,
    en: EN,
  },
  silentTranslationWarn: 'all',
})
